<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-between h-100 p-mobile-15">
        <grid-col col="4" mobile="12" class="text-align-center">
        <grid-row class="justify-content-center align-item-center mt-100">
            <grid-col col="12">
                <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>
                <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40">
                    {{"FeedbackSent" | translate}}
                </div>
                <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10">
                    {{"FeedbackSubmitted" | translate}}
                </div>
            </grid-col>
        </grid-row>
        </grid-col>
        <grid-col col="12">
            <grid-row class="justify-content-center align-item-center mb-100">
                <grid-col col="4" mobile="12">
                    <button class="btn-dft-border" (click)="done()">
                        {{ "Done" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>